// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicyError_container__QyuzS","text":"PolicyError_text__prETO"};